// import {map, size} from "lodash";
import React from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";

import Input from "../ReadOnlyInput";
import { Flex, Label, VerticalSeparator, Text } from "../styles";
import { timeStampToDate } from "../../../../utils/formats";

const CustomLabel = styled(Label)`
  margin-right: 5px;
  margin-bottom: 0;
`;
const CustomText = styled(Text)`
  margin-bottom: 5px;
`;

const TempoRelacionamentoSection = (props) => {
  const { dataEmissaoOld } = props;

  return (
    <>
      <Grid container justifyContent="space-around">
        <Grid item xs={12} sm={5}>
          <Flex direction="column" height="100px" align="center">
            <CustomText width="100%" align="center">
              Tempo de relacionamento com o Grupo Sinosserra:
            </CustomText>
            <Flex height="auto">
              <CustomLabel width="90px" height="100%" align="center">
                Data Nota Fiscal
              </CustomLabel>
              <CustomLabel
                width="80px"
                fontSize="10px"
                height="100%"
                align="center"
              >
                (primeira compra)
              </CustomLabel>
              <Input
                width="95px"
                justify="center"
                loading={false}
                value={timeStampToDate(dataEmissaoOld)}
              />
            </Flex>
          </Flex>
        </Grid>
        <Grid item sm={0} sx={{ display: { xs: "none", sm: "block" } }}>
          <VerticalSeparator />
        </Grid>
        <Grid item xs={12} sm={5}>
          <Flex direction="column" height="100px" align="center">
            <CustomText width="100%" align="center">
              Tempo de relacionamento com a Financeira:
            </CustomText>
            <Flex height="auto">
              <CustomLabel width="116px" height="100%" align="center">
                Data primeiro contato
              </CustomLabel>
              <Input width="115px" justify="center" loading={false} value="" />
            </Flex>
          </Flex>
        </Grid>
      </Grid>
    </>
  );
};

export default TempoRelacionamentoSection;
